const REGEX = {
  // eslint-disable-next-line no-useless-escape
  PASSWORD: /^[A-Za-z0-9!@"#$%&'()*+,\-.\/:;<=>?\[\\\]^_`{|}~]{8,50}$/,
  GRAFFER_DOMAIN: /^(graffer.jp|[-\w]+\.graffer.jp)$/,
  ZENKAKU_KATAKANA: /^[ァ-ヶー]+$/,
};

export default REGEX;
